<template>
  <CFooter class="mt-4 mx-4 mb-2 py-3 theme-rounded-lg bg-theme-white shadow">
    <div class="d-flex justify-content-between align-items-center text-theme-primary">
      Trees4Trees@org
    </div>
    <div class="text-theme-primary">
      GekoWeb v{{ $helpers.getVersionInfo() }}
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'AppFooter',
}
</script>
